import dayjs from 'dayjs'

export type GeneratePlanningParams = {
  projectId: string
  startDate: string
  durationWeeks: number
}

export type AIPlanPayload = {
  meetings?: Array<{
    title: string
    date: string
    time: string
    duration: number
    activities?: Array<{
      title: string
      planning: string
    }>
  }>
}

export function generateWeeklyDates(startDate: string, weeks: number): string[] {
  const base = dayjs(startDate)
  const dates: string[] = []

  for (let i = 0; i < weeks; i++) {
    const date = base.add(i, 'week').format('YYYY-MM-DD')
    dates.push(date)
  }

  return dates
}
export function validatePlanningParams(params: GeneratePlanningParams): void {
  const { projectId, startDate, durationWeeks } = params

  if (!projectId || projectId.trim().length === 0) {
    throw new Error('ID do projeto ausente')
  }

  if (!startDate || !dayjs(startDate, 'YYYY-MM-DD', true).isValid()) {
    throw new Error('Data inicial inválida (esperado formato YYYY-MM-DD)')
  }

  if (!Number.isFinite(durationWeeks) || durationWeeks <= 0 || !Number.isInteger(durationWeeks)) {
    throw new Error('Duração deve ser um número inteiro maior que zero')
  }

  if (durationWeeks > 52) {
    throw new Error('Duração não pode exceder 52 semanas')
  }
}

export function getMeetingTitle(index: number, aiPlan?: AIPlanPayload): string {
  return `Encontro ${index}`
}

export function getMeetingTime(index: number, aiPlan?: AIPlanPayload): string {
  return '08:00'
}

export function getMeetingDuration(index: number, aiPlan?: AIPlanPayload): number {
  return 60
}

export function getActivityTitle(index: number, aiPlan?: AIPlanPayload): string {
  return `Atividade ${index}`
}

export function getActivityPlanning(index: number, aiPlan?: AIPlanPayload): string {
  return `<p>Descrição da atividade ${index}</p>`
}

export const PLANNING_CONFIG = {
  DEFAULT_TIME: '08:00',
  DEFAULT_DURATION: 60,
  ENABLE_PENDENCY_JOURNAL: false,
  MAX_WEEKS: 52,
} as const
